var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("div", { staticClass: "h-full bg-white flex" }, [
        _c("div", { staticClass: "min-w-0 flex-1" }, [
          _c("div", { staticClass: "h-full flex relative" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-full h-full p-4 flex flex-col overflow-y-auto lg:p-8",
              },
              [
                _c("div", { staticClass: "flex flex-col gap-y-6" }, [
                  _c("div", { staticClass: "flex flex-col gap-y-2" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                      },
                      [_vm._v(_vm._s(_vm.$t("exam.question.title")))]
                    ),
                    _c("p", { staticClass: "text-xl font-bold" }, [
                      _vm._v(_vm._s(_vm.bankExam.examTitle)),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex flex-col gap-y-2" }, [
                    _c("div", { staticClass: "flex items-center gap-x-2" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                        },
                        [_vm._v(_vm._s(_vm.$t("exam.question.number")))]
                      ),
                      _c("p", { staticClass: "text-sm break-words" }, [
                        _vm._v(
                          _vm._s(_vm.bankExam.questionList?.length) + "개"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "flex items-center gap-x-6" }, [
                      _c("div", { staticClass: "flex items-center gap-x-2" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "w-max border border-blue-400 rounded-xl px-2 bg-blue-400 text-sm text-white leading-6",
                          },
                          [_vm._v(_vm._s(_vm.$t("exam.question.choice")))]
                        ),
                        _c("p", { staticClass: "text-sm break-words" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("exam.question.amount", {
                                0: _vm.bankExam.questionList?.filter(
                                  (question) =>
                                    question.questionType === "CHOICE"
                                ).length,
                              })
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex items-center gap-x-2" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "w-max border border-blue-400 rounded-xl px-2 bg-blue-400 text-sm text-white leading-6",
                          },
                          [_vm._v(_vm._s(_vm.$t("exam.question.subjective")))]
                        ),
                        _c("p", { staticClass: "text-sm break-words" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("exam.question.amount", {
                                0: _vm.bankExam.questionList?.filter(
                                  (question) =>
                                    question.questionType === "SUBJECTIVE"
                                ).length,
                              })
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", [_c("TestbankResultCorrectTable")], 1),
                _c(
                  "div",
                  {
                    staticClass: "min-w-0 flex-1",
                    class: {
                      "opacity-50 pointer-events-none":
                        !_vm.hasEmceeRole() &&
                        _vm.roomExamUsersAnswerObj[_vm.me.userId]?.completed,
                    },
                  },
                  _vm._l(_vm.bankExam.questionList, function (question, i) {
                    return _c(
                      question.questionType === "CHOICE"
                        ? "RoomExamQuestionChoice"
                        : "RoomExamQuestionSubjective",
                      {
                        key: question.questionId,
                        tag: "component",
                        attrs: { index: i, question: question },
                      }
                    )
                  }),
                  1
                ),
                !_vm.hasEmceeRole()
                  ? _c(
                      "GrmBtn",
                      {
                        staticClass: "mt-3",
                        attrs: { size: "md" },
                        on: { click: _vm.onCompleteExam },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                `exam.submit.${
                                  _vm.roomExamUsersAnswerObj[_vm.me.userId]
                                    ?.completed
                                    ? "edit.title"
                                    : "complete"
                                }`
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            !_vm.hasEmceeRole()
              ? _c(
                  "div",
                  {
                    staticClass:
                      "w-full p-1 flex justify-end items-center absolute top-0",
                  },
                  [_c("RoomExamTimer", { staticClass: "rounded-lg" })],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm.hasEmceeRole()
          ? _c(
              "div",
              [
                _c("TestbankViewInfo", {
                  staticClass:
                    "h-full absolute top-0 bottom-0 transition-all lg:relative lg:top-auto lg:bottom-auto lg:right-auto",
                  class: [_vm.isTestbankViewInfoOpen ? "right-0" : "-right-64"],
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center items-center absolute inset-0 pointer-events-none lg:hidden",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-4 h-7 border border-gray-300 bg-gray-200 rounded flex justify-center items-center absolute transition-all pointer-events-auto",
                        class: [
                          _vm.isTestbankViewInfoOpen
                            ? "right-60 transform translate-x-1/2"
                            : "right-0",
                        ],
                        on: { click: _vm.onToggleTestbankViewInfo },
                      },
                      [
                        _c("GrmIcon", {
                          attrs: {
                            icon: `arrow-${
                              _vm.isTestbankViewInfoOpen ? "right" : "left"
                            }`,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      !_vm.bankExam.bankExamId ? _c("RoomExamLoading") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }